<template>
  <v-app>
    <NavBar />
    <v-main id="v-main">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import '@/styles/styles.scss'
import _ from 'lodash'
import NavBar from '@/components/ui/NavBar'
import { auth } from '@/providers/firebase'
import { getTaxonomy } from '@/utils/wpApiUtils'
import { mapActions } from 'vuex'
export default {
  name: 'App',
  components: { NavBar },
  data() {
    return {}
  },
  methods: {
    ...mapActions(['setTaxonomies', 'setNoUser'])
  },
  mounted() {
    if (process.env.NODE_ENV === 'production') {
      document.getElementById('v-main').classList.add('production-style')
    }

    /**
     * the taxonomy scheme has several uses in this app.
     * load it here and save to global store
     */
    getTaxonomy()
      .then(data => {
        this.setTaxonomies(data)
      })
      .catch(err => {
        console.warn(err)
      })

    // store the user's preferred route, if they're detected take them there
    const newLoc = this.$route?.query?.to ?? '/'
    const existQuery = _.omit(this.$route?.query, ['to']) ?? {}
    auth.onAuthStateChanged(user => {
      console.log('user state changed')
      if (user === null) {
        this.setNoUser(true)
      } else {
        this.$router.push({ path: newLoc, query: existQuery })
      }
    })
  }
}
</script>

<style lang="scss" scoped>
#v-main {
  height: calc(100vh - 64px);
  overflow: hidden;

  &.production-style {
    padding: 0px !important;
  }
}
</style>
